var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chevron_down_svg__chevron_down",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 10.53a.75.75 0 1 0-1.06-1.06l1.06 1.06ZM12 14l-.53.53a.75.75 0 0 0 1.06 0L12 14ZM8.53 9.47a.75.75 0 0 0-1.06 1.06l1.06-1.06Zm6.94 0-4 4 1.06 1.06 4-4-1.06-1.06Zm-2.94 4-4-4-1.06 1.06 4 4 1.06-1.06Z",
    fill: "currentColor"
  })));
};
export default SvgChevronDown;